import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
const InvestmentsReport = (props) => {
  const [state, setState] = useState([]);
  const [responsemessage, setresponsemessage] = useState("");
  const [inputs, setInputs] = useState({});
  const handleInputChange = (event) => {
    const { name, type, value, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    setInputs((inputs) => ({
      ...inputs,
      [name]: ["categoryId", "statusId", "wardId"].includes(name)
        ? parseInt(inputValue, 10)
        : inputValue,
    }));
  };
  const fetchData = (fromDate, toDate) => {
    setresponsemessage("");
    setState([]);
    let url =
      "api/reports/investment?fromDate=" + fromDate + "&toDate=" + toDate;

    Api.get(url)
      .then(function (response) {
        if (response.data.length == 0) {
          setresponsemessage("No data found");
        }
        setState(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  const loadData = async () => {
    let fromDate = inputs.fromDate;
    if (fromDate === undefined || fromDate === "") {
      fromDate = null;
    }
    let toDate = inputs.toDate;
    if (toDate === undefined || toDate === "") {
      toDate = null;
    }

    fetchData(fromDate, toDate);
  };
  useEffect(() => {
    fetchData(null, null);
  }, []);
  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: printRef, // ✅ new API for v3+
    documentTitle: "My PDF Document",
  });
  const MyComponentToPrint = React.forwardRef((props, ref) => (
    <div className="row" ref={ref}>
      <div className="col-sm-12">
        <h5 className="text-center">Ministry of Tourism and Wildlife</h5>
        <h5 className="text-center">National Tourism Service Portal</h5>
        <h5 className="text-center">Investments Report</h5>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            {state.map((k) => {
              return (
                <tr>
                  <td>{k.id}</td>
                  <td>{k.name}</td>
                  <td>{k.description}</td>
                  <td>{k.date}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="4">DATE: {convertTimestampToDate(Date.now())} </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="col-sm-2"></div>
    </div>
  ));
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Investments Report</li>
      </ol>
      <h1 class="page-header mb-3">Investments Report</h1>
      <div style={{ backgroundColor: "white" }}>
        <hr />

        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-3">
              <button
                onClick={handlePrint}
                style={{
                  padding: "10px 15px",
                  background: "#28a745",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                Print to PDF
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  From Date:
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  required
                  value={inputs.fromDate || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="col-sm-5">
              <div className="form-group">
                <label htmlFor="countyId" className="font-weight-bold">
                  To Date:
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="toDate"
                  required
                  value={inputs.toDate || ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="col-sm-1">
              <div className="form-group">
                <button
                  onClick={loadData}
                  style={{
                    padding: "10px 15px",
                    background: "#28a745",
                    color: "white",
                    border: "none",
                    marginTop: "20px",
                    borderRadius: "6px",
                  }}
                >
                  Load
                </button>
              </div>
            </div>
          </div>
          {state.length > 0 ? (
            <div ref={printRef}>
              <MyComponentToPrint ref={printRef} />
            </div>
          ) : null}
        </div>

        <h3>{responsemessage}</h3>
      </div>
    </div>
  );
};
export default InvestmentsReport;
